(ns manage.content-variant-ocp.view
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            [common.flags :refer [use-flag]]
            [common.ocp.view :refer [defocp ocp]]
            [common.widgets.asset-upload :as upload]
            [common.widgets.form-field :refer [form-field]]
            [common.widgets.input :refer [input]]
            [common.widgets.radio :refer [radio-group]]
            [linked.core :as l]
            [manage.column-classification-table.view :as class-table]
            [manage.content-mapping-table.view :as content-mapping-table]
            [manage.content-variant-ocp.db.authentication :as auth]
            [manage.content-variant-ocp.db.schedule :as schedule]
            [manage.content-variant-ocp.db.sheet-import :as form]
            [manage.feed-importer-ocp.db :refer [interval-options reduced-interval-options]]
            [manage.feed-importer-ocp.view :as feed-importer-ocp]
            [manage.feed-lookup-table.view :as lookup-table]
            [re-frame.core :as rf]
            [reagent.core :as r]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui content-tab []
  ($ Stack
     {:p 3
      :spacing 3}
     ($ :span "Configure your source by entering your URL or uploading your sheet.")
     ($ form-field
        {:label "URL"
         :err-msg (form/use-error-message [:url])
         :data-testid "feed-url-input"}
        ($ input (form/use-bind-control [:url])))
     ($ upload/upload
        {:enableEdit false
         :resumable? true
         :onChange #(rf/dispatch [:form.content-variant.sheet-import/on-change :url %])
         :path [::asset]
         :extensions ".json, .csv"})))

(defui authentication-tab []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.content-variant.authentication/open]))
                  [])
  ($ Stack
     {:p 3
      :spacing 3}
     ($ form-field
        {:label "Authentication type"
         :err-msg (auth/use-error-message [:api-key-field-type])
         :data-testid :api-key-field-type-input}
        (r/as-element
         [radio-group
          (merge (auth/use-bind-control [:api-key-field-type])
                 {:options [{:label "None"
                             :value "none"
                             :id :none}
                            {:label "Query Parameter"
                             :value "query-parameter"
                             :id :query-parameter}
                            {:label "Header Parameter"
                             :value "header-parameter"
                             :id :header-parameter}]})]))
     ($ form-field
        {:label "API key name"
         :err-msg (auth/use-error-message [:api-key-field-name])
         :data-testid :feed-api-field-name-input}
        ($ input (auth/use-bind-control [:api-key-field-name])))
     ($ form-field
        {:label "API key secret"
         :err-msg (auth/use-error-message [:api-key])
         :data-testid :feed-api-key-input}
        ($ input (auth/use-bind-control [:api-key])))))

(defui column-classification-tab []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.content-variant.column-classification/open]))
                  [])
  (let [url (use-subscribe [:form.content-variant/url])
        auto-map-disabled? (use-subscribe [:form.content-variant.column-classification/auto-map-disabled])]
    (if (not-empty url)
      ($ Stack {:sx #js {:py 2}
                :spacing 2}
         ;; Because MUI Stack sets it's childrens margins to 0,
         ;; we need to wrap the Button with a Stack with padding,
         ;; to simulate horizontal margin on the Button.
         ($ Stack {:sx #js {:px 3}}
            ($ Button {:variant "contained"
                       :on-click (fn [^js _event]
                                   (rf/dispatch [:form.content-variant.column-classification/auto-map-fields]))
                       :disabled auto-map-disabled?}
               "Auto-classify columns"))
         ($ class-table/table))
      ($ :span {:data-testid :mapping-tab-no-mapping}
         "We could not load any feed data, please provide a valid feed in the previous step."))))

(defui lookup-tab []
  (let [url (use-subscribe [:form.content-variant/url])]
    (if (not-empty url)
      ($ lookup-table/table {:value-sub :table.content-lookup/value})
      ($ :span {:data-testid :lookup-tab-no-mapping}
         "We could not load any feed data, please provide a valid feed in the previous step."))))

(defui content-mapping-tab []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.content-variant.content-mapping/open]))
                  [])
  (let [url (use-subscribe [:form.content-variant/url])
        auto-map-disabled? (use-subscribe [:form.content-variant.content-mapping/auto-map-disabled])]
    (if (not-empty url)
      ($ Stack {:sx #js {:py 2}
                :spacing 2}
         ;; Because MUI Stack sets it's childrens margins to 0,
         ;; we need to wrap the Button with a Stack with padding,
         ;; to simulate horizontal margin on the Button.
         ($ Stack {:sx #js {:px 3}}
            ($ Button {:variant "contained"
                       :on-click (fn [^js _event]
                                   (rf/dispatch [:form.content-variant.content-mapping/auto-map-content]))
                       :disabled auto-map-disabled?}
               "Auto-map content"))
         ($ content-mapping-table/table))
      ($ :span {:data-testid :mapping-tab-no-mapping}
         "We could not load any feed data, please provide a valid feed in the previous step."))))

(defui scheduling-tab []
  (uix/use-effect (fn []
                    (rf/dispatch [:form.content-variant.feed-schedule/open]))
                  [])
  (let [url (use-subscribe [:form.content-variant/url])
        bind-control-fn #(schedule/use-bind-control [:schedule])
        schedule-error-message-fn #(schedule/use-error-message [:schedule])
        timezone-error-message-fn #(schedule/use-error-message [:timezone])
        scheduling-options (if (use-flag :content-variants-all-scheduling-options)
                             interval-options
                             reduced-interval-options)]
    (if (not-empty url)
      ($ feed-importer-ocp/scheduling-tab
         {:bind-control-fn bind-control-fn
          :schedule-error-message-fn schedule-error-message-fn
          :timezone-error-message-fn timezone-error-message-fn
          :interval-options scheduling-options
          :interval-test-id :form.content-variant.feed-schedule.interval
          :timezone-test-id :form.content-variant.feed-schedule.timezone})

      ($ Box {:p 3}
         ($ :span {:data-testid :scheduling-tab-no-mapping}
            "We could not load any feed data, please provide a valid feed in the previous step.")))))

(defocp content-variant-crud :content-variant/crud
  {:width "60%"
   :disable-padding true}
  []
  (let [allowed-to-edit? (use-subscribe [:resource.user/allowed? "adsets2.edit"])
        mode (use-subscribe [:form.content-variant/mode])
        feed-id (use-subscribe [:form.content-variant/feed-id])
        classification-errors? (use-subscribe [:form.content-variant.column-classification/errors?])
        [active-tab set-active-tab] (uix/use-state :information)
        next-tab (fn [k]
                   (when k
                     (set-active-tab k)
                     k))
        tabs (l/map :information {:label "1. Data sheet import"
                                  :button-disabled? (not allowed-to-edit?)
                                  :button-label "Save and continue →"
                                  :content ($ content-tab)
                                  :on-submit (fn [_e]
                                               (rf/dispatch [:form.content-variant/set-dirty])
                                               (rf/dispatch [:form.content-variant.sheet-import/submit (partial next-tab :authentication)]))}
                    :authentication {:label "2. Authentication"
                                     :button-disabled? (nil? feed-id)
                                     :button-label "Save and continue →"
                                     :content ($ authentication-tab)
                                     :on-submit (fn [_e]
                                                  (rf/dispatch [:form.content-variant/set-dirty])
                                                  (rf/dispatch [:form.content-variant.authentication/submit (partial next-tab :column-classification)]))}
                    :column-classification {:label "3. Column classification"
                                            :disabled? (nil? feed-id)
                                            :button-disabled? (or classification-errors? (not allowed-to-edit?))
                                            :button-label "Save and continue →"
                                            :content ($ column-classification-tab)
                                            :on-submit (fn [_e]
                                                         (rf/dispatch [:form.content-variant/set-dirty])
                                                         (rf/dispatch [:form.content-variant.column-classification/submit (partial next-tab :lookup)]))}
                    :lookup {:label "4. Targeting details"
                             :disabled? classification-errors?
                             :button-disabled? (not allowed-to-edit?)
                             :button-label "Save and continue →"
                             :content ($ lookup-tab)
                             :on-submit (fn [_e]
                                          (rf/dispatch [:form.content-variant/set-dirty])
                                          (rf/dispatch [:form.content-variant/update-field-formats (partial next-tab :content-mapping)]))}
                    :content-mapping {:label "5. Content mapping"
                                      :disabled? classification-errors?
                                      :button-disabled? (or (use-subscribe [:form.content-variant.content-mapping/errors?]) (not allowed-to-edit?))
                                      :button-label "Save and continue →"
                                      :content ($ content-mapping-tab)
                                      :on-submit (fn [_e]
                                                   (rf/dispatch [:form.content-variant/set-dirty])
                                                   (rf/dispatch [:form.content-variant.content-mapping/submit (partial next-tab :scheduling)]))}
                    :scheduling {:label "6. Scheduling"
                                 :disabled? classification-errors?
                                 :button-disabled? (not allowed-to-edit?)
                                 :button-label "Save and finish"
                                 :content ($ scheduling-tab)
                                 :on-submit (fn [_e]
                                              (rf/dispatch [:form.content-variant/set-dirty])
                                              (rf/dispatch [:form.content-variant.feed-schedule/submit (partial next-tab nil)]))})
        current (get tabs active-tab)]
    ($ ocp
       {:title (if (= mode :create) "Import data sheet" "Edit configuration")
        :on-submit (:on-submit current)
        :header ($ Tabs
                   {:value active-tab
                    :onChange (fn [_e v] (set-active-tab (keyword v)))
                    :sx #js {:px 3
                             :backgroundColor "grey.90"}
                    :variant "scrollable"}
                   (for [[k v] tabs]
                     ($ Tab
                        {:key k
                         :value k
                         :disabled (:disabled? v)
                         :label (:label v)})))
        :footer ($ Button
                   {:variant "contained"
                    :type "submit"
                    :disabled (:button-disabled? current)}
                   (:button-label current))}
       (:content current))))
